<template>
  <div class="bg-white rounded-lg border border-gray-200 shadow-sm">
    <button
      @click="isExpanded = !isExpanded"
      class="w-full flex items-center justify-between p-3 text-left gap-2"
    >
      <div class="flex items-start gap-2 min-w-0 flex-1">
        <svg class="w-5 h-5 text-primary30 shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 24 24">
          <path :d="mdiAccountCircle" />
        </svg>
        <div class="min-w-0 flex-1">
          <p class="text-sm font-semibold text-gray-700 leading-tight">{{ doctorName }}</p>
          <p v-if="doctorCrm" class="text-xs text-gray-400">CRM {{ doctorCrm }}</p>
          <p v-if="breadcrumb" class="text-[10px] text-gray-400 leading-tight mt-1">
            {{ breadcrumb }}
          </p>
          <p v-if="startDetail" class="text-[11px] text-gray-500 leading-tight mt-0.5">
            {{ startDetail }}
          </p>
        </div>
      </div>
      <svg
        class="w-4 h-4 text-gray-400 shrink-0 transition-transform duration-200"
        :class="{ 'rotate-180': isExpanded }"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path :d="mdiChevronDown" />
      </svg>
    </button>
    <Transition name="expand">
      <div v-if="isExpanded" class="px-3 pb-3 border-t border-gray-100 pt-2">
        <div v-if="allocatedBy" class="text-xs text-gray-500 mb-2">
          <span class="font-semibold">Escalado por:</span> {{ allocatedBy }}
        </div>

        <div class="text-xs text-gray-700 mb-2 leading-relaxed">
          <p v-if="startDetail">
            De <span class="font-semibold">{{ startDetail }}</span>
          </p>
          <p v-if="endDetail">
            Até <span class="font-semibold">{{ endDetail }}</span>
          </p>
          <p v-if="timezone" class="text-[10px] text-gray-400">Horário de {{ timezone }}</p>
        </div>

        <div class="grid grid-cols-2 gap-x-4 gap-y-1.5 text-xs">
          <div>
            <p class="font-semibold text-gray-400">Formação</p>
            <p class="text-gray-700">{{ formation || 'N/A' }}</p>
          </div>
          <div>
            <p class="font-semibold text-gray-400">Tipo</p>
            <p class="text-gray-700">{{ dutyType || 'N/A' }}</p>
          </div>
          <div>
            <p class="font-semibold text-gray-400">Posição</p>
            <p class="text-gray-700">{{ positionName || 'N/A' }}</p>
          </div>
          <div>
            <p class="font-semibold text-gray-400">Turno</p>
            <p class="text-gray-700">{{ shiftName || 'N/A' }}</p>
          </div>
          <div>
            <p class="font-semibold text-gray-400">Time</p>
            <p class="text-gray-700">{{ team || 'N/A' }}</p>
          </div>
          <div>
            <p class="font-semibold text-gray-400">Valor</p>
            <p class="text-gray-700">{{ value || 'N/A' }}</p>
          </div>
          <div>
            <p class="font-semibold text-gray-400">Repasse</p>
            <p class="text-gray-700">{{ repassMode || 'N/A' }}</p>
          </div>
          <div>
            <p class="font-semibold text-gray-400">Proporcionalidade</p>
            <p class="text-gray-700">{{ proportionalityRule || 'N/A' }}</p>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { mdiAccountCircle, mdiChevronDown } from '@mdi/js'

const props = defineProps<{
  doctorName: string
  doctorCrm?: string
  scheduleName: string
  positionName: string
  shiftName?: string
  team?: string
  timeRange: string
  dutyType?: string
  value?: string
  formation?: string
  repassMode?: string
  proportionalityRule?: string
  breadcrumb?: string
  allocatedBy?: string
  startDetail?: string
  endDetail?: string
  timezone?: string
  defaultExpanded?: boolean
}>()

const isExpanded = ref(props.defaultExpanded !== false)
</script>

<style scoped>
.expand-enter-active,
.expand-leave-active {
  transition: all 200ms ease;
  overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
  opacity: 0;
  max-height: 0;
}

.expand-enter-to,
.expand-leave-from {
  opacity: 1;
  max-height: 200px;
}
</style>
